import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Left from "../assets/images/left.png";
import logo from "../assets/images/logo.png";
import Shop from "../assets/images/shop.png";
import Menu from "../assets/images/menu.png";
import Dropdown from "react-bootstrap/Dropdown";

export default function Header() {
  const navigate = useNavigate();

  return (
    <>
      <header>
        <div className="custom_container ">
          <div className="login_logo  mb_40">
            <button
              style={{
                backgroundColor: "white",
                marginRight: 20,
                borderWidth: 0,
              }}
              onClick={() => navigate(-1)}
            >
              <img src={Left} alt="" />{" "}
            </button>
            <img src={logo} alt="" />{" "}
          </div>
        </div>
      </header>
    </>
  );
}
